import { useState } from 'react'
import { Api } from '../api'

export default function RequestPasswordResetPage() {
  const [email, setEmail]     = useState('')
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setLoading(true)
    try {
      await Api.passwordResetRequest({ passwordResetRequest: { email } })
    } catch {
      // Intentionally swallow errors to avoid email enumeration
    } finally {
      setLoading(false)
      setSubmitted(true)
    }
  }

  return (
    <div className="min-h-screen bg-ink-950 flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-8">
          <img src="/bear_icon_transparent.svg" alt="" className="h-16 w-auto brightness-150 mb-4" />
          <h1 className="font-display font-black text-2xl tracking-widest text-bear uppercase leading-none">
            Kodiak Labs
          </h1>
          <p className="font-mono text-[10px] tracking-[0.25em] text-ink-300 uppercase mt-1">
            Reset your password
          </p>
        </div>

        {submitted ? (
          <div className="bg-ink-800 rounded-2xl border border-ink-600/50 p-6">
            <p className="font-mono text-sm text-ink-200">
              If that email is associated with an account, you'll receive a reset link shortly.
            </p>
            <button
              onClick={() => { window.location.hash = 'status' }}
              className="mt-4 font-mono text-[10px] tracking-[0.15em] uppercase text-ink-400 hover:text-ink-200 transition-colors"
            >
              Back to sign in
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="bg-ink-800 rounded-2xl border border-ink-600/50 p-6 space-y-4">
            <div>
              <label className="block font-mono text-[10px] tracking-[0.2em] uppercase text-ink-200 mb-1.5">
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                className="w-full bg-ink-900 border border-ink-600 rounded-lg px-3 py-2.5
                  font-mono text-sm text-ink-100 placeholder-ink-500
                  focus:outline-none focus:border-bear/60 transition-colors"
                placeholder="you@example.com"
                autoComplete="email"
                required
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full px-4 py-2.5 rounded-xl bg-bear text-ink-50
                font-mono text-[11px] tracking-[0.15em] uppercase font-semibold
                hover:bg-bear-light transition-colors cursor-pointer
                disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'Sending…' : 'Send reset link'}
            </button>
            <button
              type="button"
              onClick={() => { window.location.hash = 'status' }}
              className="w-full font-mono text-[10px] tracking-[0.15em] uppercase text-ink-400 hover:text-ink-200 transition-colors"
            >
              Back to sign in
            </button>
          </form>
        )}
      </div>
    </div>
  )
}
